<template>
  <div id="qrCodeManager">
    <div class="allMenuHead">
      <div v-if="$childMenu.indexOf('渠道二维码') >= 0" :class="step ? 'active' : ''" @click="toUrl('channelQrCode', 2)" class="d_i headTab p_r">渠道二维码<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('统计报表') >= 0" :class="!step ? 'active' : ''" @click="toUrl('channelFollowList', 1)" class="d_i headTab p_r">统计报表<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
export default {
  name: 'qrCodeManager',
  data () {
    return {
      step: true,
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
    }
  },
  created () {
    Time = setInterval(p => {
      if (window.location.href.indexOf('channelQrCode') >= 0) {
        this.step = true
      }
      if (window.location.href.indexOf('channelFollowList') >= 0 || window.location.href.indexOf('followDetailList') >= 0 || window.location.href.indexOf('registerDetailList') >= 0) {
        this.step = false
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
  },
  methods: {
    toUrl (url, num) {
      if (num === 1) {
        this.step = true
      } else {
        this.step = false
      }
      this.$router.push({
        name: url
      })
      if (url === 'channelFollowList') {
        localStorage.isDis = true
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/qrCodeManager/qrCodeManager.vue